import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GoalProvider } from './context/GoalContext';
import HomeScreen from './screens/HomeScreen';
import CreateGoalStep1 from './screens/CreateGoalStep1';
import CreateGoalStep2 from './screens/CreateGoalStep2';
import CreateGoalStep3 from './screens/CreateGoalStep3';
import ConfirmationScreen from './screens/ConfirmationScreen';
import GoalDetailScreen from './screens/GoalDetailScreen';
import EditGoalScreen from './screens/EditGoalScreen';
import GoalsScreen from './screens/GoalsScreen';
import CardsScreen from './screens/CardsScreen';
import MoreScreen from './screens/MoreScreen';
import './App.css';

function App() {
  return (
    <GoalProvider>
      <BrowserRouter>
        <div className="app-shell">
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/create-goal/step1" element={<CreateGoalStep1 />} />
            <Route path="/create-goal/step2" element={<CreateGoalStep2 />} />
            <Route path="/create-goal/step3" element={<CreateGoalStep3 />} />
            <Route path="/create-goal/confirmation" element={<ConfirmationScreen />} />
            <Route path="/goal/:id" element={<GoalDetailScreen />} />
            <Route path="/goal/:id/edit" element={<EditGoalScreen />} />
            <Route path="/cards" element={<CardsScreen />} />
            <Route path="/goals" element={<GoalsScreen />} />
            <Route path="/more" element={<MoreScreen />} />
          </Routes>
        </div>
      </BrowserRouter>
    </GoalProvider>
  );
}

export default App;
